import 'malihu-custom-scrollbar-plugin';

export const ProductSliderController = () => {

  enquire.register('(max-width:1023px)', {
    match : () => {
      $('.brands').mCustomScrollbar({
        axis: 'x',
        mouseWheel: true,
        autoDraggerLength: false,
        scrollbarPosition: 'inside',
        documentTouchScroll: true,
        callbacks: {
          onInit: () => {
            // const initBrand = $('.brand:eq(0)').attr('data-brand');
            // $('.brands').find('.mCSB_dragger').append('<span class="scrollerTitle">' + initBrand + '</span>');
          },
          whileScrolling: () => {
            // updateBrand();
          }
        }
      });
    },

    unmatch : () => {
      $('.brands').mCustomScrollbar('destroy');
    },
  });

}



const updateBrand = () => {
  const $items = $('.brand');
  const $dragger = $('.brands').find('.mCSB_dragger');
  const draggerPos = $dragger.offset().left + $dragger.width();

  $items.each((i, el) => {
    const elX = el.getBoundingClientRect().x
    const date = $(el).attr('data-brand');

    if(draggerPos > elX) {
      $dragger.find('.scrollerTitle').text(date);
    }
  })
}


const sliderShadow = () => {
  let height = $('.brand__visual__bg').height();

  $('.brands').append('<div class="brands-boxshadow"></div>');
  $('.brands-boxshadow').height(height);

  $(window).on("window:resize", (e) => {
    height = $('.brand__visual__bg').height();
    $('.brands-boxshadow').height(height);
  })
}



// WEBPACK FOOTER //
// ./src/js/controllers/ProductSliderController.js